exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-22a9594c]{position:fixed;z-index:999;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-color:rgba(0,0,0,.3)}.loader-msg[data-v-22a9594c]{position:fixed;top:50%;margin-top:6rem}", ""]);

// exports
